import { createContext, useContext } from 'react'
import { useHoverMenu } from './useHoverMenu'

type MenuHoverContextType = ReturnType<typeof useHoverMenu>

const MenuHoverContext = createContext<MenuHoverContextType | undefined>(
  undefined,
)

export function HoverMenuProvider({ children }: { children: React.ReactNode }) {
  const value = useHoverMenu()
  return (
    <MenuHoverContext.Provider value={value}>
      {children}
    </MenuHoverContext.Provider>
  )
}

export function useHoverMenuContext() {
  const context = useContext(MenuHoverContext)
  if (!context)
    throw new Error(
      'useHoverMenuContext must be used within a MenuHoverProvider',
    )
  return context
}
